import React, { useEffect, useState } from 'react';
import { array, object, string, number, shape, propTypes } from 'prop-types';
import get from 'lodash/get';
import { InfiniteStoryList } from '../../rows/infinite-story-list';
import { PageHeading } from '../../molecules/page-heading';
import RightSidebar from '../right-side-bar';
import BackToTop from '../../atoms/back-to-top';
import AdWithPlaceholder from '../ad-with-placeholder';
import { isMobile } from 'react-device-detect';

import './infinite-story-with-heading.m.css';
import { connect, useSelector } from 'react-redux';

const InfiniteStoryWithHeading = (props) => {
  const isSubscriber = useSelector((state) => get(state, ['userData', 'isSubscriber'], false));
  const params = {
    stories: get(props, ['data', 'stories']),
    baseApi: get(props, ['data', 'baseApi'], ''),
    fullWidthResult: true,
    hostImage: get(props, ['config', 'cdn-image'], ''),
    sectionHeading: get(props, ['data', 'section', 'display-name'], ''),
    offset: get(props, ['data', 'offset'], 20),
    fetchCollectionStories: get(props, ['data', 'fetchCollectionStories'], false),
  };
  const [showAd, setShowAd] = useState(true);
  useEffect(() => {
    if (window.location.href.includes('/bq-brand-studio/')) {
      setShowAd(false);
    }
  }, []);

  return (
    <div className="container">
      <BackToTop />

      {showAd && !isSubscriber ? (
        <div>
          {!isMobile ? (
            <div
              styleName="belowHeader-sp-ad"
              className="responsive-ad desktop-only content-center"
            >
              <AdWithPlaceholder adtype="SpListingBelowHeader" height="90px" width="728px" />
            </div>
          ) : (
            <div className="responsive-ad mobile-only content-center">
              <AdWithPlaceholder adtype="BelowHeaderMobile" height="100px" width="320px" />
            </div>
          )}
        </div>
      ) : null}

      <div styleName="story-list" className="row-section sidebar">
        <div>
          <PageHeading
            title={params.sectionHeading}
            hasStories={params.stories.length > 0}
            hideResultFor={true}
            smallHeading
            count={get(props, ['data', 'total'], 0)}
          />
          <div styleName="infinite-container">
            <InfiniteStoryList {...params} />
          </div>
        </div>
        <div>
          {!isMobile && showAd && !isSubscriber ? (
            <div
              styleName="above-videos-sp-listing-ad"
              className="responsive-ad desktop-only content-center"
            >
              <AdWithPlaceholder adtype="SpListingAboveMostRead" height="250px" width="300px" />
            </div>
          ) : null}

          <RightSidebar source="InfiniteStoryList" />

          {!isMobile && showAd && !isSubscriber && props.pageType !== 'market-page' ? (
            <div className="responsive-ad desktop-only content-center">
              <AdWithPlaceholder adtype="SpListingBelowMostRead" height="600px" width="300px" />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

InfiniteStoryWithHeading.propTypes = {
  data: shape({
    stories: array,
    section: object,
    baseApi: string,
    offset: number,
    pageType: string,
  }),
  config: propTypes,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ['qt', 'pageType'], ''),
});

export default connect(mapStateToProps)(InfiniteStoryWithHeading);
